export class CameraChanges {
    x = 0;

    y = 0;

    zoom = 1;

    direction = 0;

    reset() {
        this.x = 0;
        this.y = 0;
        this.zoom = 1;
        this.direction = 0;
    }
}
